'use strict'

let phone_number_country_code_length

function restrict_movements_over_cc(e, phone_number_field){
	if(e.type === 'focus') {
		phone_number_country_code_length = phone_number_field.placeholder.match(/(\(\d+\))/)[1].length
		if(phone_number_field.selectionStart <= phone_number_country_code_length){
			phone_number_field.selectionStart = phone_number_country_code_length + 1
		}
	}
	else if (e.key === 'Tab') {
		e.preventDefault()
	}
	else if(e.key === 'ArrowLeft' && phone_number_field.selectionStart <= phone_number_country_code_length){
		phone_number_field.selectionStart = phone_number_country_code_length + 1
	}
	else if(e.key === 'ArrowRight' && phone_number_field.selectionStart < phone_number_country_code_length){
		phone_number_field.selectionStart = phone_number_country_code_length + 1
	}
}

export {
	restrict_movements_over_cc
}

